import { useState } from "react";
import { ChevronsUpDown, Check, Plus } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";

export function SearchSelect({ items, value, onChange, placeholder = "Choose…", disabled, testid, createLabel, onCreate, invalid, className = "" }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const cur = items.find((i) => i.id === value);
  return (
    <Popover open={open} onOpenChange={(o) => { setOpen(o); if (!o) setQ(""); }}>
      <PopoverTrigger asChild disabled={disabled}>
        <button type="button" role="combobox" aria-expanded={open} data-testid={testid} data-value={value || ""}
          className={`w-full min-h-10 rounded-lg border bg-white px-2.5 text-sm flex items-center justify-between gap-2 text-left disabled:bg-stone-50 ${invalid ? "border-rose-500 ring-1 ring-rose-400" : "border-input"} ${className}`}>
          <span className={`truncate ${cur ? "" : "text-stone-400"}`}>{cur ? cur.label : placeholder}</span><ChevronsUpDown className="h-4 w-4 shrink-0 text-stone-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[var(--radix-popover-trigger-width)] min-w-[260px]" align="start">
        <Command>
          <CommandInput placeholder="Type to search…" value={q} onValueChange={setQ} data-testid={`${testid}-search`} />
          <CommandList className="max-h-[280px]">
            <CommandEmpty>No match.</CommandEmpty>
            <CommandGroup>
              {items.map((i) => (
                <CommandItem key={i.id} value={`${i.label} ${i.sub || ""} ${i.id}`} onSelect={() => { onChange(i.id, i); setOpen(false); }} data-testid={`${testid}-opt-${i.id}`} className="min-h-[40px]">
                  <Check className={`h-4 w-4 mr-2 ${value === i.id ? "opacity-100" : "opacity-0"}`} />
                  <span className="flex-1 truncate">{i.label}{i.sub && <span className="block text-[11px] text-stone-500">{i.sub}</span>}</span>
                </CommandItem>))}
            </CommandGroup>
          </CommandList>
          {onCreate && <button type="button" className="w-full border-t px-3 min-h-[44px] text-sm flex items-center gap-2 font-medium hover:bg-stone-50" onClick={() => { setOpen(false); onCreate(q); }} data-testid={`${testid}-create`}><Plus className="h-4 w-4" />{createLabel}{q ? ` “${q}”` : ""}</button>}
        </Command>
      </PopoverContent>
    </Popover>
  );
}
